import FluentUiIcon from "../../../../../../../assets/fluent-ui-icon";

export const contextMenuItems = [
  {
    Text: "Edit",
    Icon: <FluentUiIcon name={"OpenBundle"} color={"#212121"} size={20} />,
    onClick: null,
  },
];

export const ParseContextMenuItems = (listener) => {
  return contextMenuItems.map((item) => {
    return {
      ...item,
      onClick: (e) => listener(e, item.Text),
    };
  });
};